import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { fetchProgramsApi, fetchMiniPlayerApi } from '@/service'

export const useBroadcastStore = defineStore('broadcast', () => {
  const programs = ref({})
  const programItems = computed(() => programs.value?.items ?? [])
  const miniPlayer = ref({})

  const fetchMiniPlayer = () => {
    return fetchMiniPlayerApi().then((response) => {
      miniPlayer.value = response
      return Promise.resolve(response)
    })
  }

  const fetchPrograms = async () => {
    return fetchProgramsApi().then((response) => {
      programs.value = response
      return Promise.resolve(response)
    })
  }

  return {
    programs,
    programItems,
    miniPlayer,
    fetchPrograms,
    fetchMiniPlayer
  }
})
